<template>
  <div class="flex h-screen flex-col">
    <Header />
    <main class="inline-flex w-full flex-1 flex-col items-center bg-slate-100">
      <section
        class="flex min-h-[calc(100vh-160px)] w-screen flex-1 flex-col items-center justify-center bg-slate-50 px-7 pb-12 pt-8 md:min-h-max lg:pt-12"
        :style="{maxWidth: `${props.maxWidth}`}"
      >
        <slot />
      </section>
    </main>
    <Footer />
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  maxWidth: {
    type: String,
    default: '768px',
    required: false
  }
})
</script>

<style scoped lang="scss"></style>
